import { createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
import { defineComponent, reactive, inject } from "vue";
import _ from "lodash";
import { homePageContextKey } from "@/context/home-page";
import useHomePageKnockout from "@/hooks/home-page-knockout";
import { raceRoundPC } from "@/config/homePage";
import PreviewDialog from "@/components/common/preview-dialog.vue";
import { BattleList } from "./battle-list";
export default defineComponent({
  name: "Eliminated",
  setup() {
    const {
      homePageState
    } = inject(homePageContextKey);

    // 组件状态
    const state = reactive({
      active: 1,
      // 第几轮
      tabActive: 1,
      // 赛区
      showPreview: false,
      dateTabList: [{
        value: 1,
        type: "tab1"
      }, {
        value: 2,
        type: "tab2"
      }, {
        value: 3,
        type: "tab3"
      }, {
        value: 4,
        type: "tab4"
      }],
      tabList: [{
        label: "【星光赛区】对阵队伍",
        value: 1
      }, {
        label: "【火种赛区】对阵队伍",
        value: 2
      }]
    });
    const {
      firstHalf,
      secondHalf,
      isRepechage
    } = useHomePageKnockout(homePageState, state);
    const handleChange = (active, startDate) => {
      // 第一项
      if (!startDate) {
        state.active = active;
        return;
      }
      const openingDate = +new Date(startDate).setHours(23, 59, 59); // 获取开放当天 0 点事件
      const now = +new Date();
      if (now < openingDate) {
        // TODO: 给个提示？
        return;
      }
      state.active = active;

      // 重置 场次 选项
      state.tabActive = !isRepechage(state.active) ? 1 : 2;
    };
    const handleTabs = value => {
      state.tabActive = value;
    };
    return () => {
      // 顶部切换
      const builtListItem = _.map(raceRoundPC[homePageState.raceQuartertype], (item, index) => {
        return _createVNode("div", {
          "onClick": () => {
            var _raceRoundPC$homePage;
            return handleChange(item.value, (_raceRoundPC$homePage = raceRoundPC[homePageState.raceQuartertype][index]) === null || _raceRoundPC$homePage === void 0 ? void 0 : _raceRoundPC$homePage.date);
          },
          "class": ["tab-item", state.active === item.value && "active"]
        }, [_createVNode("div", {
          "class": "left"
        }, [_createVNode("span", {
          "class": "label"
        }, [item.label]), _createVNode("span", {
          "class": "date"
        }, [item.dateText])]), item.value !== 4 && _createVNode("img", {
          "class": "divide",
          "src": require("@/assets/img/m/homePage/tt-tab-divide.png")
        }, null)]);
      });
      return _createVNode("div", {
        "class": "box"
      }, [_createVNode("div", {
        "class": "top"
      }, [builtListItem]), _createVNode("div", null, [_createVNode("img", {
        "onClick": () => state.showPreview = true,
        "class": "btn",
        "src": require("@/assets/img/m/homePage/ttdz-btn.png")
      }, null)]), _createVNode("div", {
        "class": "tabs"
      }, [!isRepechage(state.active) ? _.map(state.tabList, item => {
        return _createVNode("div", {
          "onClick": () => handleTabs(item.value),
          "class": ["tabs-item", state.tabActive === item.value ? "active-tab" : ""]
        }, [item.label]);
      }) : _createVNode("div", {
        "class": ["tabs-item"]
      }, [_createTextVNode("\u3010\u590D\u6D3B\u8D5B\u3011\u5BF9\u9635\u961F\u4F0D ")])]), _createVNode("div", {
        "class": "table-box"
      }, [state.tabActive === 1 && _createVNode(BattleList, {
        "gameData": firstHalf.value
      }, null), state.tabActive === 2 && _createVNode(BattleList, {
        "gameData": secondHalf.value
      }, null)]), _createVNode(PreviewDialog, {
        "visible": state.showPreview,
        "onUpdate:visible": $event => state.showPreview = $event
      }, {
        default: () => [_createVNode("img", {
          "class": "img-against",
          "src": require("@/assets/img/m/homePage/tt-popup.png")
        }, null)]
      })]);
    };
  }
});